import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { createMixerPageTracker } from './mixers';

export default function MixerAnalytics() {
  const location = useLocation();
  const tracker = useRef(null);
  if (!tracker.current) tracker.current = createMixerPageTracker();
  useEffect(() => {
    tracker.current(window.location);
  }, [location.pathname]);
  return null;
}
